// "Signaler une erreur": the small report any signed-in person can raise from
// inside the app. It is read back by the platform operator under
// /api/superadmin (see superadmin-api.ts) — there is no club-side list.

import { apiClient } from "./api-client";

/** What the reporter says is wrong. */
/** "privacy" is a request about one's own data, sent from "My data", not offered in the report dialog. */
export type SignalementCategory = "data" | "bug" | "content" | "other" | "privacy";

/** What the report is about, when the screen the user is on could name it. */
export type SignalementSubjectType = "program_item" | "flashcard" | "club" | "person" | "screen" | "grading_system";

export interface SignalementSubject {
  type: SignalementSubjectType;
  /** Stable identifier of the flagged thing ("item:12"), when there is one. */
  id?: string;
  /** What the operator should read instead of a key ("O-goshi", "Élément du programme"). */
  label?: string;
}

export interface CreatedSignalement {
  id: number;
  status: string;
  createdAt: string;
  /** True when the very same report had already been sent moments ago. */
  duplicate: boolean;
}

/** The kinds of report the dialog offers: every category but the privacy request. */
export const SIGNALEMENT_CATEGORIES: readonly Exclude<SignalementCategory, "privacy">[] = ["data", "bug", "content", "other"];

export async function createSignalement(input: {
  category: SignalementCategory;
  message?: string;
  subject?: SignalementSubject | null;
  pageUrl?: string;
}): Promise<CreatedSignalement> {
  const response = await apiClient.call<{ success: boolean; data: CreatedSignalement }>("/signalements", {
    method: "POST",
    body: JSON.stringify({
      category: input.category,
      message: input.message?.trim() ? input.message.trim() : undefined,
      subjectType: input.subject?.type,
      subjectId: input.subject?.id,
      subjectLabel: input.subject?.label,
      pageUrl: input.pageUrl,
    }),
  });

  return response.data;
}

/** The in-app path of the screen the report is raised from: never the origin, never the referrer. */
export function currentPagePath(): string {
  return window.location.pathname + window.location.search;
}
